import { usePopup } from "@/app/hooks/use_popup"
import { Dialog, DialogPanel } from "@headlessui/react"
import { ReactNode } from "react"

interface FullScreenPopupProps {
  isOpen: boolean
  close: () => void
  children: ReactNode
}

export function FullScreenPopup({
  isOpen,
  close,
  children,
}: FullScreenPopupProps) {
  const { popupRef, closePopup } = usePopup(isOpen, close)

  if (!isOpen) return children

  return (
    <Dialog
      open={isOpen}
      onClose={closePopup}
      className="fixed inset-0 z-50"
      onClick={() => closePopup()}>
      <div className="fixed inset-0 bg-main-700/50" />
      <div className="fixed inset-0 z-10 sm:w-screen" ref={popupRef}>
        <div className="flex min-h-full items-center justify-center text-center sm:items-center">
          <DialogPanel
            transition
            className="relative w-full border border-main-400 bg-main-light text-left transition-all data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-300 data-[enter]:ease-out data-[leave]:ease-in sm:p-3 lg:w-11/12 lg:rounded-3xl"
            onClick={(e) => e.stopPropagation()}>
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
